import React from 'react';
import Header from './Header';
import Footer from './Footer';
import VerticalSensorCard from './VerticalSensorCard';
import '../styles/ProcessSensorsFluidSensors.css';

import pressureImg from '../assets/PressureVacuumSensorMain.png';
import levelImg from '../assets/level-sensor.png';
import flowImg from '../assets/flow-sensor-image.png';
import temperatureImg from '../assets/temp_sensors_main.png';
import analyticalImg from '../assets/analytical-main.png';

const processSensors = [
  {
    title: 'Pressure / Vacuum Sensors',
    image: pressureImg,
    points: [
      'Sensors and transmitters with integrated evaluation',
      'Specially for the use in hygienic applications',
      'Excellent overload protection and long-term stability',
      'Measuring ranges of -1…..1000 bar',
      'Variable process connection using adapters',
    ],
    link: '/products/PressureVacuumSensor',
  },
  {
    title: 'Level Sensors',
    image: levelImg,
    points: [
      'High reliability due to the elimination of mechanical components',
      'Different function principles: Guided wave radar, capacitive and hydrostatic',
      'Devices for limit level detection or continuous level measurement',
      'Clearly visible LED display',
      'Suitable for all common industrial and process fluids',
    ],
    link: '/products/LevelSensor',
  },
  {
    title: 'Flow Sensors / Flow Meters',
    image: flowImg,
    points: [
      'For liquids and gases',
      'Versions for the use in hygienic applications',
      'Variable process connection using adapters',
      'Flow monitoring also for aggressive media',
    ],
    link: '/products/FlowSensorsFlowMeters',
  },
  {
    title: 'Temperature Sensors',
    image: temperatureImg,
    points: [
      'Units with integrated or separate evaluation electronics',
      'Modular concept for a large variety of applications',
      'High process safety due to self-monitoring',
      'Variable process connection using adapters',
      'High shock and vibration resistance',
    ],
    link: '/products/TemperatureSensors',
  },
  {
    title: 'Analytical Sensors',
    image: analyticalImg,
    points: [
      'Compact conductivity sensors for the food industry',
      'Inductive and conductive conductivity sensors',
      'Robust sensors for the monitoring of oil quality',
      'Relative humidity and concentration of particles',
    ],
    link: '/products/AnalyticalSensors',
  },
];

const ProcessFluidSensors = () => {
  return (
    <div className="process-fluid-sensors-page">
      <Header />
      <div className="content-wrapper">
        <section className="process-fluid-sensors-hero">
          <h1>Process / Fluid Sensors</h1>
          <p>Explore precision-engineered process and fluid sensors for diverse industrial applications.</p>
        </section>

        <section className="sensor-grid">
          {processSensors.map((sensor, index) => (
            <a href={sensor.link} className="sensor-card-link" key={index}>
              <VerticalSensorCard
                image={sensor.image}
                title={sensor.title}
                points={sensor.points}
              />
            </a>
          ))}
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default ProcessFluidSensors;
